module.exports = __webpack_public_path__ + "img/linus.5e721bb1.png";